<template>
	<v-header title="登记预约" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<div style="height: 35px;">
				<Button v-show="list.length===0" type="info" ghost @click="getGroupList()" size="small"
					icon="md-add">新增</Button>
				<label style="color: #999999;"> 到院预约登记体检</label>
			</div>
			<Card style=" margin-bottom: 15px;" v-for=" item in list">
				<template #title>
					<b v-if="item.state==='未签到'" style="color: red;">{{item.state}}</b>
					<b v-else>{{item.state}}</b>
				</template>
				<template #extra>
					<a href="#" @click.prevent="update(item)">
						修改
					</a>
					&ensp;&ensp;|&ensp;&ensp;
					<a href="#" @click.prevent="del(item)">
						删除
					</a>
				</template>
				<Row style="height: 25px;">
					<Col span="6">
					预约时间
					</Col>
					<Col span="18">
					<b>{{converterEx.toDateString(item.registerDate)+" "+item.registerTime.substring(0,5)}}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					姓名
					</Col>
					<Col span="18">
					<b>{{item.patientName}}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					证件类型
					</Col>
					<Col span="18">
					<b>{{item.idCardType}}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					证件号
					</Col>
					<Col span="18">
					<b>{{item.idCardNo}}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					电话
					</Col>
					<Col span="18">
					<b>{{item.patientPhone}}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					性别
					</Col>
					<Col span="18">
					<b>{{item.sex}}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					生日
					</Col>
					<Col span="18">
					<b>{{ converterEx.toDateString(item.birthday) }}</b>
					</Col>
				</Row>
				<Row style="height: 25px;">
					<Col span="6">
					健康顾问
					</Col>
					<Col span="18">
					<b>{{ item.consultant }}</b>
					</Col>
				</Row>
			</Card>
		</div>
		<Drawer title="预约登记" placement="bottom" :mask-closable="false" height="100%" v-model="view.showGroupList">
			<Card style="width:100%;margin-bottom: 10px;" v-for="item in groupList">
				<template #title>
					{{converterEx.toDateString(item.registerDate)}}
				</template>
				<template #extra>
					<Tag v-if='converterEx.toDateString(oldRegister.registerDate)===converterEx.toDateString(item.registerDate)'
						color="error">
						{{'原约 '+converterEx.toDateString(oldRegister.registerDate)+" "+oldRegister.registerTime.substring(0,5)}}
					</Tag>
				</template>
				<Row style="text-align: center;">
					<Col span="12" style="border-style: none dashed none none;border-color: #DDDFE0;border-width: 1px;">
					<b tyle="font-size: 16px;  padding-right: 10px;">上午&ensp;</b>
					<Button v-if="item.morning===0" shape="circle" disabled>已排满</Button>
					<Button v-else shape="circle"
						@click="getRegisterNumber(item.registerDate,'上午')">余{{item.morning}}</Button>
					</Col>
					<!-- 厦门不要
					<Col span="12">
					<b tyle="font-size: 16px;  padding-right: 10px;">下午&ensp;</b>
					<Button v-if="item.afternoon===0" shape="circle" disabled>已排满</Button>
					<Button v-else shape="circle"
						@click="getRegisterNumber(item.registerDate,'下午')">余{{item.afternoon}}</Button>
					</Col>
					-->
				</Row>
			</Card>
			<div style="text-align:center" v-show="groupList.length===0">
				<Result type="warning" title="" desc="没有相关数据"></Result>
			</div>
		</Drawer>
		<Drawer :title="view.registerNumberTitle" placement="bottom" :mask-closable="false" height="100%"
			v-model="view.showRegisterNumber">
			<Row v-for="itemList in registerNumber" style="text-align: center;padding-bottom: 10px;">
				<Col v-for="item in itemList" span="6">
				<Button shape="circle" @click="save(item)">{{item.registerTime.substring(0,5) }}</Button>
				</Col>
			</Row>
			<div style="text-align:center" v-show="registerNumber.length===0">
				<Result type="warning" title="" desc="没有相关数据"></Result>
			</div>
		</Drawer>
		<div style="text-align:center" v-show="view.initComplete===true&&list.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>
<script>
	import header from "@/components/header/index";
	import {
		sysPost
	} from '@/utils/api'

	export default {
		name: 'order',
		data() {
			return {
				view: {
					title: '',
					initComplete: false,
					showGroupList: false,
					showRegisterNumber: false,
					registerNumberTitle: "",
				},
				list: [],
				groupList: [],
				registerNumber: [],
				oldRegister: {
					id: "",
					registerDate: null,
					registerTime: null,
				},
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				var that = this;
				sysPost(that, {
					"url": 'Register/List',
					"data": {}
				}, function(result) {
					that.view.initComplete = true;
					that.list = result;
				});
			},
			getGroupList() {
				var that = this;
				sysPost(that, {
					"url": 'RegisterNumber/GroupList',
					"data": {}
				}, function(result) {
					that.view.showGroupList = true;
					that.groupList = result;
				});
			},
			getRegisterNumber(RegisterDate, TimeQuantum) {
				var that = this;
				that.view.registerNumberTitle = that.converterEx.toDateString(RegisterDate) + TimeQuantum;
				sysPost(that, {
					"url": 'RegisterNumber/List',
					"data": {
						"RegisterDate": RegisterDate,
						"TimeQuantum": TimeQuantum,
						"State": '未预约'
					}
				}, function(result) {
					that.view.showRegisterNumber = true;
					that.registerNumber = result.groupEx(4);
				});
			},
			save(registerNumber) {
				if (this.isNullOrEmptyEx(this.oldRegister.id)) {
					this.$router.push({
						path: '/registerConfirm',
						query: {
							registerNumber: JSON.stringify(registerNumber)
						}
					})
				} else {
					var that = this;
					this.$Modal.confirm({
						title: '友情提示',
						content: '<p>您确认预约?</p>',
						onOk: () => {
							sysPost(that, {
								"url": 'Register/Update',
								"data": {
									"Register": that.oldRegister.id,
									"RegisterNumber": registerNumber.id,
								}
							}, function(result) {
								setTimeout(function() {
									that.$Modal.success({
										title: "预约成功",
										onOk: () => {
											location.href = location.href +
												"#reloaded";
											location.reload();
										}
									});
								}, 200)
							});
						}
					});
				}
			},
			del(item) {
				var that = this;
				this.$Modal.confirm({
					title: '友情提示',
					content: '<p>您确认取消预约?</p>',
					onOk: () => {
						sysPost(that, {
							"url": 'Register/Delete',
							"data": {
								"Id": item.id
							}
						}, function(result) {
							setTimeout(function() {
								that.$Modal.success({
									title: "删除成功",
									onOk: () => {
										location.href = location.href +
										"#reloaded";
										location.reload();
									}
								});
							}, 200)
						});
					}
				});
			},
			update(item) {
				this.oldRegister = {
					id: item.id,
					registerDate: item.registerDate,
					registerTime: item.registerTime,
				}
				this.getGroupList();
			}
		},
		components: {
			"v-header": header
		}
	}
</script>
